import React, { useCallback, useState } from "react";
import T from "prop-types";
import { translateProps } from "MODULES/shared/decorators";
import { API_BASE, ID } from "APP_ROOT/constants";
import {
  Modal,
  Close,
  Header,
  Body,
  Footer
} from "MODULES/shared/components/Modal";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Button, Col } from "react-bootstrap";
import { get, set } from "lodash";
import { arrayToProperCasedOptions } from "LIB/forms";
import { Icon } from "MODULES/shared/components";

const MUTILATION_REASONS = [
  "cutting_or_shearing",
  "crushing_or_shredding",
  "drilling_or_punching",
  "grinding_or_abrasion",
  "torching_or_thermal_mutilation",
  "notching_or_gouging",
  "certified_vendor_mutilation",
  "other"
];

export function DownloadScrapReportModal({ editing, close, url, inventory }) {
  const js = inventory.toJS();
  const [settings, setSetting] = useState({
    company_name: js.po_vendor_name,
    reference_number: js.purchase_order_code
  });
  const [changes, setChanges] = useState(0);

  const updateSetting = useCallback(
    (path, value) => {
      setSetting(set(settings, path, value));
      setChanges(changes + 1);
    },
    [settings, changes]
  );

  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Download Certificate of Destruction</h4>
      </Header>
      <Body>
        <FormRow>
          <Col md={6}>
            <label className="control-label" htmlFor="Company Name">
              Company Name
            </label>
            <input
              className="form-control"
              value={get(settings, "company_name")}
              onChange={e => updateSetting("company_name", e.target.value)}
            />
          </Col>
          <Col md={6}>
            <label className="control-label" htmlFor="Ref">
              Reference #
            </label>
            <input
              className="form-control"
              value={get(settings, "reference_number")}
              onChange={e => updateSetting("reference_number", e.target.value)}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={6}>
            <label className="control-label" htmlFor="attention">
              Attention
            </label>
            <input
              className="form-control"
              value={get(settings, "attention")}
              onChange={e => updateSetting("attention", e.target.value)}
            />
          </Col>

          <Col md={6}>
            <label className="control-label" htmlFor="form_of_mutilation">
              Form of Mutilation
            </label>
            <select
              className="form-control"
              id="form-of-mutilation"
              value={get(settings, "form_of_mutilation", null)}
              onChange={ev => {
                updateSetting("form_of_mutilation", ev.target.value);
              }}
            >
              <option value="">(Select one)</option>
              {arrayToProperCasedOptions(MUTILATION_REASONS).map(o => (
                <option value={o.value}>{o.text}</option>
              ))}
            </select>
          </Col>
        </FormRow>
      </Body>
      <Footer>
        <Button
          onClick={() => {
            close();
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          bsStyle="primary"
          onClick={() => {
            window.open(`${url}?${new URLSearchParams(settings).toString()}`);
            close();
          }}
        >
          <Icon name="download" fixed />
          &nbsp;Download
        </Button>
      </Footer>
    </Modal>
  );
}

DownloadScrapReportModal.propTypes = {
  url: T.string.isRequired
};

const withUrl = translateProps(({ inventory }) => ({
  url: `${API_BASE}/inventories/${inventory.get(ID)}/download_scrap_certificate`
}));

export default withUrl(DownloadScrapReportModal);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/DownloadScrapReport/DownloadScrapReportModal.jsx